// typeof any so that it we don't have to cast when comparing a result to the error object
export const errorObject: any = { e: {} };


// WEBPACK FOOTER //
// ./~/rxjs/src/util/errorObject.ts